
import 'components/catalog.tag'
import 'pages/persons/person-new-modal.tag'
riot.tag2('accounts-list', '  <div class="col-md-12">\n    <catalog search="true" sortable="true" object="UserAccount" handlers="{handlers}" cols="{cols}" reload="true" before-success="{getAggregation}" dblclick="{permission(personOpen, &quot;contacts&quot;, &quot;1000&quot;)}" store="accounts-list" filters="{allFilters}">\n      <yield to="body">\n        <datatable-cell name="id">{row.id}</datatable-cell>\n        <datatable-cell name="name">{row.name}</datatable-cell>\n        <datatable-cell name="inPay"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.inPay.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n        <datatable-cell name="outPay"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.outPay.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      </yield>\n      <yield to="head">\n        <button class="btn btn-primary" onclick="{parent.exportAccount}" title="Экспорт списка (XLS)" type="button"><i class="fa fa-file-excel-o" aria-hidden="true"></i></button>\n      </yield>\n      <yield to="filters">\n        <div class="well well-sm">\n          <div class="form-inline row">\n            <div class="form-group col-sm-3">\n              <label class="control-label">От даты</label>\n              <datetime-picker class="form-control" data-name="datePayee" data-sign="&gt;=" format="YYYY-MM-DD" value="{parent.startDate}"></datetime-picker>\n            </div>\n            <div class="form-group col-sm-3">\n              <label class="control-label">До даты</label>\n              <datetime-picker class="form-control" data-name="datePayee" data-sign="&lt;=" format="YYYY-MM-DD" value="{parent.endDate}"></datetime-picker>\n            </div>\n            <div class="form-group col-sm-6">\n              <label class="control-label">Тип</label>\n              <select class="form-control" data-name="isBonus">\n                <option value="">Все</option>\n                <option value="1">Только бонусы</option>\n              </select>\n            </div>\n          </div>\n        </div>\n      </yield>\n      <yield to="aggregation"><strong> Начислено:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalInPay || 0).toFixed(2) +  ⁗ ⁗}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><strong> Списано:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalOutPay || 0).toFixed(2) +  ⁗ ⁗}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><strong> Остаток:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalBalansePay || 0).toFixed(2) +  ⁗ ⁗}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong></yield>\n    </catalog>\n  </div>\n', '', '', function(opts) {
'use strict';

var _this2 = this;

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'UserAccount';
self.categoryFilters = false;
self.typeFilters = false;
self.allFilters = false;
self.managers = {};
self.operations = [];

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Ф.И.О' }, { name: 'inPay', value: 'Начисление' }, { name: 'outPay', value: 'Списание' }];

self.handlers = {
    params: {}
};

/*
self.change = e => {
    var value = e.target.value
    if (value == '') {
        self.typeFilters = false
    } else {
        //var filter = {field: 'priceType', sign: 'IN', value: value}
        self.typeFilters = [{field: 'priceType', sign: 'IN', value: value}]
    }
    self.Filters()
}
*/

self.getAggregation = function (response, xhr) {
    self.totalInPay = response.totalInPay;
    self.totalOutPay = response.totalOutPay;
    self.totalBalansePay = response.totalBalansePay;
    self.currTotal = response.currTotal;
};

self.Filters = function () {
    if (self.typeFilters && self.categoryFilters) self.allFilters = [].concat(self.typeFilters, self.categoryFilters);else if (self.typeFilters) self.allFilters = self.typeFilters;else self.allFilters = self.categoryFilters;
    self.update();
    self.tags.catalog.reload();
};

self.personOpen = function (e) {
    riot.route('/persons/' + e.item.row.id);
};

/*
self.personOpenItem = id => {
    riot.route(`/persons/${id}`)
}

self.importPersons = (e) => {
    var formData = new FormData();
    for (var i = 0; i < e.target.files.length; i++) {
        formData.append('file' + i, e.target.files[i], e.target.files[i].name)
    }

    API.upload({
        object: 'Contact',
        data: formData,
        success(response) {
            self.update();
        }
    })
}

self.exportPersons = () => {
    var params = { filters: self.allFilters }
    API.request({
        object: 'Contact',
        method: 'Export',
        data: params,
        success(response, xhr) {
            let a = document.createElement('a')
            a.href = response.url
            a.download = response.name
            document.body.appendChild(a)
            a.click()
            a.remove()
        }
    })
}

self.exportCard = (e) => {
    var _this = this

    var rows = self.tags.catalog.tags.datatable.getSelectedRows()
    var params = { id: rows[0].id }

    API.request({
        object: 'Contact',
        method: 'Export',
        data: params,
        success(response, xhr) {
            let a = document.createElement('a')
            a.href = response.url
            a.download = response.name
            document.body.appendChild(a)
            a.click()
            a.remove()
        }
    })
} */

self.exportAccount = function (e) {
    var _this = _this2;
    var params = self.handlers.params;

    API.request({
        object: 'UserAccount',
        method: 'Export',
        data: params,
        success: function success(response, xhr) {
            var a = document.createElement('a');
            a.href = response.url;
            a.download = response.name;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    });
};

/* self.getOperations = () => {
    API.request({
        object: 'BankAccountTypeOperation',
        method: 'Fetch',
        success: (response, xhr) => {
            self.operations = response.items
            self.update()
        }
    })
}

self.getManagers = () => {
    self.managers = []
    API.request({
        object: 'PermissionUser',
        method: 'Fetch',
        success(response) {
            self.managers = response.items
            self.update()
        }
    })

}

self.getContactCategory = () => {
    self.categories = []
    API.request({
        object: 'ContactCategory',
        method: 'Fetch',
        success(response) {
            for (var i = 0; i < response.items.length; i++) {
                self.categories.push(response.items[i])
                if (response.items[i].childs!== undefined) {
                    for (var ii = 0; ii < response.items[i].childs.length; ii++) {
                        self.categories.push(response.items[i].childs[ii])
                    }
                }
            }
            self.update()
        }
    })
}
*/

self.one('updated', function () {
    /*self.tags['catalog-tree'].tags.treeview.on('nodeselect', node => {
        self.selectedCategory = node.__selected__ ? node.id : undefined
        let items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes()
        if (items.length > 0) {
            let value = items.map(i => i.id).join(',')
            self.categoryFilters = [{field: 'idGroup', sign: 'IN', value}]
            } else {
            self.categoryFilters = false
        }
        self.Filters()
             //self.update()
        //self.tags.catalog.reload()
    })*/
});

//self.getContactCategory()
//self.getManagers()
//self.getOperations();

observable.on('persons-reload', function () {
    return self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/persons/accounts-list.tag